/** Application route paths used by shell-level redirects and menu generation. */
export const appRoutePaths = {
    /** Home route used as the default landing page. */
    home: '/home',
};
